import React from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { PROGRAM_TYPES } from 'utils/programHelpers'
import { PrintButton, PrintCopyright, PrintIcon } from './component.styles'
import { HighSchoolPrintStyles, PrintStyles } from './printStyles'
import { COPYRIGHT_TEXT } from './constants'

const IndividualResourcePrintControls = ({ program, onPrint }) => {
  const isHighSchool = program === PROGRAM_TYPES.HIGH_SCHOOL

  // The button lives inside the navigation, which is hidden in print output.
  // Portal the copyright line to the body so it survives and repeats on each
  // printed page via fixed positioning.
  const canPortal = typeof document !== 'undefined' && !!document.body

  return (
    <>
      <PrintStyles />
      {isHighSchool && <HighSchoolPrintStyles />}
      <PrintButton
        aria-label="Print Page"
        data-print-hidden="print-button"
        onClick={onPrint}
      >
        <PrintIcon />
        Print Page
      </PrintButton>
      {canPortal &&
        createPortal(
          <PrintCopyright aria-hidden="true" data-print-copyright>
            {COPYRIGHT_TEXT}
          </PrintCopyright>,
          document.body,
        )}
    </>
  )
}

IndividualResourcePrintControls.propTypes = {
  onPrint: PropTypes.func.isRequired,
  program: PropTypes.string,
}

export default IndividualResourcePrintControls
